<section class="recruiter-workflow">
  <div class="recruiter-workflow__container">
    <div class="recruiter-workflow__header">
      <h2 class="recruiter-workflow__title">The <span class="text-indigo-600">Hiring Journey</span> with<br>BeExpert ✨
      </h2>
      <p class="recruiter-workflow__subtitle">From job creation to hiring the best talent — all in one intelligent
        platform.</p>
      <div class="w-12 h-1 bg-indigo-500 mx-auto mt-4 rounded-full"></div>
    </div>

    <div #workflowGrid class="recruiter-workflow__grid">
      @for (step of steps; track step.number) {
      <div class="recruiter-workflow__card recruiter-workflow__card--{{ step.colorClass }}">
        <div class="recruiter-workflow__card-number">{{ step.number }}</div>

        <h3 class="recruiter-workflow__card-title">{{ step.title }}</h3>
        <p class="recruiter-workflow__card-subtitle">{{ step.subtitle }}</p>

        <!-- Mockups -->
        <div class="recruiter-workflow__mockup">
          @if (step.mockupId === 'm1') {
          <div class="font-bold text-slate-800 mb-3 border-b border-slate-200 pb-2">Create Job</div>
          <div class="space-y-3 relative">
            <div
              class="absolute right-0 top-0 w-8 h-8 rounded-lg bg-indigo-500/10 text-indigo-500 flex items-center justify-center animate-pulse">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
                <path d="M12 2L15 9L22 12L15 15L12 22L9 15L2 12L9 9L12 2Z" />
              </svg>
            </div>
            <div>
              <label class="block text-[10px] text-slate-500 mb-1">Job Title</label>
              <div class="px-2 py-1.5 border border-slate-200 rounded text-slate-700 bg-white">Product Manager</div>
            </div>
            <div>
              <label class="block text-[10px] text-slate-500 mb-1">Experience</label>
              <div class="px-2 py-1.5 border border-slate-200 rounded text-slate-700 bg-white">4-5 Years</div>
            </div>
            <div>
              <label class="block text-[10px] text-slate-500 mb-1">Location</label>
              <div class="px-2 py-1.5 border border-slate-200 rounded text-slate-700 bg-white">Bangalore, India</div>
            </div>
          </div>
          } @else if (step.mockupId === 'm2') {
          <div class="flex items-center justify-between font-bold text-slate-800 mb-2">
            <span>Product Manager</span>
            <span class="text-[9px] px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full">149 applicants</span>
          </div>
          <div class="flex gap-4 text-[10px] border-b border-slate-200 pb-2 mb-2">
            <span class="text-blue-600 border-b border-blue-600 pb-2 -mb-2 font-semibold">All (149)</span>
            <span class="text-slate-500">New (12)</span>
            <span class="text-slate-500">Screening (64)</span>
          </div>
          <div class="space-y-2">
            <div class="flex items-center gap-2 bg-white p-1.5 rounded border border-slate-100">
              <div
                class="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-[8px] font-bold">
                AS</div>
              <span class="font-medium text-[10px] flex-1">Ananya Sharma</span>
              <span class="text-[9px] text-blue-600 font-semibold">New</span>
            </div>
            <div class="flex items-center gap-2 bg-white p-1.5 rounded border border-slate-100">
              <div
                class="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-[8px] font-bold">
                RV</div>
              <span class="font-medium text-[10px] flex-1">Rohan Verma</span>
              <span class="text-[9px] text-amber-500 font-semibold">Screening</span>
            </div>
            <div class="flex items-center gap-2 bg-white p-1.5 rounded border border-slate-100">
              <div
                class="w-5 h-5 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-[8px] font-bold">
                AK</div>
              <span class="font-medium text-[10px] flex-1">Arjun Singh</span>
              <span class="text-[9px] text-indigo-500 font-semibold">Assessment</span>
            </div>
          </div>
          } @else if (step.mockupId === 'm3') {
          <div class="flex items-center justify-between font-bold text-slate-800 mb-2">
            <span>Assessment in Progress</span>
            <span class="text-[9px] px-2 py-0.5 bg-emerald-50 text-emerald-600 rounded-full flex items-center gap-1">
              <span class="w-1 h-1 rounded-full bg-emerald-500 animate-pulse"></span> Live
            </span>
          </div>
          <div class="bg-slate-900 rounded-lg p-2 flex items-start gap-2 text-white">
            <div class="w-16 h-12 bg-slate-800 rounded flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                class="w-4 h-4 text-slate-600">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div>
              <div class="text-[9px] text-slate-400">Time Left</div>
              <div class="text-sm font-bold text-emerald-400">45:00</div>
            </div>
          </div>
          <div class="mt-3 space-y-1">
            <div class="h-1 w-full bg-slate-200 rounded-full overflow-hidden">
              <div class="h-full bg-emerald-500 w-[60%]"></div>
            </div>
            <div class="flex justify-between text-[8px] text-slate-500"><span>Progress</span><span>60%</span></div>
          </div>
          } @else if (step.mockupId === 'm4') {
          <div class="flex items-center justify-between font-bold text-slate-800 mb-2">
            <span>Interview 01:23</span>
            <span class="text-[9px] px-2 py-0.5 bg-rose-50 text-rose-600 rounded-full flex items-center gap-1">
              <span class="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse"></span> REC
            </span>
          </div>
          <div class="bg-indigo-900 rounded-lg h-24 relative flex items-center justify-center overflow-hidden">
            <div class="absolute inset-0 bg-gradient-to-t from-indigo-950 to-transparent"></div>
            <div class="w-10 h-10 rounded-full border-2 border-indigo-500/30 flex items-center justify-center">
              <div
                class="w-8 h-8 rounded-full bg-indigo-500/50 flex items-center justify-center text-white text-xs font-bold">
                AS</div>
            </div>
            <div class="absolute bottom-2 left-2 flex gap-1">
              <div class="w-1 h-3 bg-white/40 rounded-full"></div>
              <div class="w-1 h-4 bg-white/80 rounded-full"></div>
              <div class="w-1 h-2 bg-white/40 rounded-full"></div>
            </div>
          </div>
          <div class="flex justify-between mt-3 text-center">
            <div>
              <div class="text-[9px] text-slate-500">Tech Score</div>
              <div class="font-bold text-indigo-600">95%</div>
            </div>
            <div>
              <div class="text-[9px] text-slate-500">Comm Score</div>
              <div class="font-bold text-indigo-600">88%</div>
            </div>
          </div>
          } @else if (step.mockupId === 'm5') {
          <div class="font-bold text-slate-800 mb-3 border-b border-slate-200 pb-2">Candidates Lists</div>
          <table class="w-full text-[10px] text-slate-600">
            <thead>
              <tr>
                <th class="text-left pb-2 font-medium text-slate-400">Metrics</th>
                <th class="pb-2">
                  <div
                    class="w-6 h-6 mx-auto rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-[8px]">
                    AS</div>
                </th>
                <th class="pb-2">
                  <div
                    class="w-6 h-6 mx-auto rounded-full bg-rose-100 text-rose-600 flex items-center justify-center font-bold text-[8px]">
                    RV</div>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-100">
              <tr>
                <td class="py-1.5">Assessment</td>
                <td class="text-center font-semibold py-1.5 text-blue-600">98%</td>
                <td class="text-center font-semibold py-1.5 text-rose-600">92%</td>
              </tr>
              <tr>
                <td class="py-1.5">Interview</td>
                <td class="text-center font-semibold py-1.5 text-blue-600">88%</td>
                <td class="text-center font-semibold py-1.5 text-rose-600">85%</td>
              </tr>
              <tr>
                <td class="py-1.5">Comm Skills</td>
                <td class="text-center font-semibold py-1.5 text-blue-600">Excellent</td>
                <td class="text-center font-semibold py-1.5 text-rose-600">Good</td>
              </tr>
            </tbody>
          </table>
          } @else if (step.mockupId === 'm6') {
          <div class="flex-1 flex flex-col items-center justify-center text-center p-2">
            <div class="w-10 h-10 rounded-full bg-emerald-100 text-emerald-500 flex items-center justify-center mb-3">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" class="w-5 h-5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <div
              class="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-[10px] mb-2">
              RV</div>
            <div class="font-bold text-slate-800">Rahul Verma</div>
            <div class="text-[9px] text-slate-500 mb-2">Product Manager</div>
            <div
              class="px-2 py-1 bg-emerald-50 text-emerald-600 rounded text-[8px] font-semibold border border-emerald-100">
              92% Match Score</div>
          </div>
          }
        </div>

        <ul class="recruiter-workflow__card-list">
          @for (feature of step.features; track feature) {
          <li>
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 mr-2 flex-shrink-0 inline check-icon">
              <path fill-rule="evenodd"
                d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                clip-rule="evenodd" />
            </svg>
            {{ feature }}
          </li>
          }
        </ul>

        <button class="recruiter-workflow__mockup-btn">{{ step.buttonText }}</button>
        @if (step.mockupId === 'm6') {
        <button class="recruiter-workflow__mockup-btn-outline">Download Offer Letter</button>
        }
      </div>
      }
    </div>

    <!-- Candidate Funnel at a Glance -->
    <div class="recruiter-funnel relative mt-24">
      <div class="flex items-center justify-center mb-10 relative">
        <div class="absolute left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-blue-100 to-transparent z-0">
        </div>
        <h3 class="recruiter-funnel__title relative z-10 bg-white px-6 m-0 text-xl font-bold text-slate-800">Candidate
          Funnel at a Glance</h3>
      </div>

      <div #funnelPipeline
        class="recruiter-funnel__pipeline flex flex-col md:flex-row justify-between items-center md:items-start gap-8 md:gap-4 relative">
        <!-- Connecting arrow line for desktop -->
        <div class="hidden md:block absolute top-[2.5rem] left-[10%] right-[10%] h-[1px] -z-10"></div>

        @for (fStep of funnelSteps; track fStep.title; let last = $last) {
        <div class="funnel-step flex flex-col items-center text-center flex-1 relative z-10 w-full">
          <div
            class="w-20 h-20 rounded-full border-[6px] border-{{ fStep.color }}-50 bg-white flex items-center justify-center text-{{ fStep.color }}-500 mb-4 shadow-sm relative">
            <div class="absolute inset-[-6px] rounded-full border border-{{ fStep.color }}-100 z-[-1]"></div>
            <!-- Icons -->
            @if (fStep.icon === 'users') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-8 h-8">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            } @else if (fStep.icon === 'clipboard') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-8 h-8">
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
              <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
              <path d="M9 14l2 2 4-4"></path>
            </svg>
            } @else if (fStep.icon === 'video') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-8 h-8">
              <polygon points="23 7 16 12 23 17 23 7"></polygon>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
            </svg>
            } @else if (fStep.icon === 'star') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-8 h-8">
              <polygon
                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
              </polygon>
            </svg>
            } @else if (fStep.icon === 'trophy') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-8 h-8">
              <path d="M8 21h8M12 17v4M7 4h10M5 4h14v4a7 7 0 0 1-14 0V4z"></path>
            </svg>
            }
          </div>

          <div class="font-bold text-slate-800 text-xs lg:text-sm h-10 flex items-center justify-center text-center lg:whitespace-nowrap">{{ fStep.title }}</div>
          <div class="text-3xl font-black text-{{ fStep.color }}-600 mt-1">{{ fStep.count }}</div>
          <div class="text-[10px] text-slate-400 font-medium mb-3 uppercase tracking-wider">{{ fStep.label }}</div>

          @if (fStep.isPill) {
          <div
            class="border border-slate-200 rounded-full px-3 py-1 flex items-center gap-1.5 text-[9px] text-slate-500 max-w-[140px]">
            <span class="truncate">{{ fStep.subtitle }}</span>
            <div class="w-4 h-4 rounded-full bg-blue-500 text-white flex items-center justify-center flex-shrink-0">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-2.5 h-2.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
          </div>
          } @else {
          <div class="text-[10px] text-slate-500 max-w-[140px] leading-relaxed">{{ fStep.subtitle }}</div>
          }
        </div>

        @if (!last) {
        <div class="hidden lg:flex items-start justify-center h-20 w-8 text-slate-300 relative">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-5 h-5 absolute top-7">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        }
        }
      </div>
    </div>
  </div>
</section>